import script from "./OrderHistoryTreca.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryTreca.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryTreca.vue?vue&type=style&index=0&id=64a8c168&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a8c168"]])

export default __exports__